import { AType, EType, summon, tagged } from "@silversea-ssc/functional-support"
import { rebrandMaterialized } from "@ssc-booking/functional-support"
import { UUID } from "@ssc-booking/functional-support/src/uuid"
import { v4 as uuidv4 } from "uuid"

export const CybersourcePayload = summon((F) =>
    F.record(
        F.string({
            FastCheckURI: (_x, { fastCheck }) =>
                fastCheck.string({ minLength: 1 }).map((s: string) => s.replace("$", "S")),
        }),
        F.string({ FastCheckURI: (_x, { fastCheck }) => fastCheck.string({ minLength: 1 }) }),
    ),
)
export type CybersourcePayload = AType<typeof CybersourcePayload>

export const CybersourcePayment = /* @__PURE__ */ summon((F) =>
    F.interface(
        {
            type: F.stringLiteral("cybersource"),
            signature: F.string(),
            payload: CybersourcePayload(F),
        },
        "CybersourcePayment",
    ),
)
export type CybersourcePayment = AType<typeof CybersourcePayment>
export type CybersourcePaymentEncoded = EType<typeof CybersourcePayment>

const _DemetraPaymentId = /* @__PURE__ */ rebrandMaterialized(UUID, "DemetraPaymentId")
export type DemetraPaymentId = AType<typeof _DemetraPaymentId>

export const DemetraPaymentId = Object.assign(_DemetraPaymentId, {
    new: (): DemetraPaymentId => uuidv4() as DemetraPaymentId,
    fromUUID: (uuid: UUID): DemetraPaymentId => uuid as DemetraPaymentId,
})

export const DemetraPayment = /* @__PURE__ */ summon((F) =>
    F.interface(
        {
            type: F.stringLiteral("demetra"),
            paymentId: DemetraPaymentId(F),
        },
        "DemetraPayment",
    ),
)
export type DemetraPayment = AType<typeof DemetraPayment>
export type DemetraPaymentEncoded = EType<typeof DemetraPayment>

export const Payment = tagged("type")({
    cybersource: CybersourcePayment,
    demetra: DemetraPayment,
})
export type Payment = AType<typeof Payment>
export type PaymentEncoded = EType<typeof Payment>
